import api from "../../../../lib/API"; // nithinok

export const updateActivity = async (id, activityId, data) => {
  const response = await api.patch(`/verve-leads/${id}/activities/${activityId}`, data);
  return response.data || response;
};
